import { useEffect, useState, useRef, useCallback } from "react";

type UseCountdownLogoutReturn = {
  countdown: number;
  cancel: () => void;
  logout: () => void;
};

/**
 * 自動ログアウトのカウントダウンを管理するフック
 * @param countdownSeconds カウントダウン秒数
 * @returns countdown - 残り秒数, cancel - カウントダウンをキャンセルする関数, logout - ログアウト処理を実行する関数
 */
export function useCountdownLogout(
  countdownSeconds: number,
): UseCountdownLogoutReturn {
  const [countdown, setCountdown] = useState(countdownSeconds);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const cancel = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const logout = useCallback(() => {
    cancel();
    window.location.reload();
  }, [cancel]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCountdown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    return () => cancel();
  }, [cancel]);

  useEffect(() => {
    if (countdown === 0) {
      // ログイン画面に遷移
      logout();
    }
  }, [countdown, logout]);

  return { countdown, cancel, logout };
}
